export const Summary = {
	about: [
		`Somos Super Latin Store, ubicada en 30 Wilson Avenue en Newark, Nueva Jersey. Nuestra empresa nacio en Noviembre del 2014, 
		con el objetivo de satisfacer a nuestros clientes hispanos a traves de los productos y servicios ofrecidos. A lo largo de 
		esta trayectoria en el mercado nos hemos ganado la confiaza de nuestros consumidores al servir a la comunidad Latina de manera eficaz. 
		Importamos mercaderia de Latinoamerica para cumplir con las necesidades de las personas que acuden a nuestro local. Dicho inventario 
		abarca: Granos secos, Hierbas Medicinales, Productos enlatados, productos congelados, galletas y caramelos, productos medicinales 
		permitidos bajo venta libre y mas…`,
		`Brindamos servicios de envios de Dinero hacia cualquier parte del mundo con nuestra afiliada Afex/Ria Money Transfer. 
		La cual le permite recibir el dinero en la mayoria de las agencias y Bancos  de manera rapida y segura.
		Actualmente contamos con nuevos servicios que van desde pagos de billes, money orders, recargas nacionales e internacionales y paqueteria.`
	]
};
